import { render, staticRenderFns } from "./ResetDialog.vue?vue&type=template&id=3bcd984e&scoped=true"
import script from "./ResetDialog.vue?vue&type=script&lang=js"
export * from "./ResetDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcd984e",
  null
  
)

export default component.exports